export default "__VITE_ASSET__CW$crANO__"